export default {"src":"/_next/static/media/security.8b610506.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};